import * as React from 'react'
import { NewButton, NewModal, newTheme, ROLE_NAME } from 'prace-common-components'
import Grid from '@material-ui/core/Grid'
import { $Description } from 'components/DeleteElementModal/styles'
import { DefaultRoleModalProps } from './types'

export const DefaultRoleModal: React.FC<DefaultRoleModalProps> = 
({ role, defaultUserList, onSave, onClose }) => <NewModal open title={`${ROLE_NAME[role]} default User Pool`} type='warning-fill' onClose={onClose}>
  <div>
    <Grid item>
      <p>Are you sure you want to proceed?</p>
    </Grid>
    <Grid item>
      <$Description>{defaultUserList !== '' ? 
        `This will change the ${ROLE_NAME[role]} user pool for the cutoffs you select in the buttons below.` : 
        `This will remove the default ${ROLE_NAME[role]} user pool so that it no longer applies automatically to any new cutoffs. Existing cutoffs with this default user pool will not be affected.`}
      </$Description>
    </Grid>
    {defaultUserList !== '' ?
      <Grid spacing={2} container>
        <Grid item>
          <NewButton onClick={() => onSave(false)}>Change only cutoffs without a custom pool</NewButton>
        </Grid>
        <Grid item>
          <NewButton btncolor={newTheme.colors.primary} onClick={() => onSave(true)}>Change every cutoff</NewButton>
        </Grid>
      </Grid>
      : <NewButton onClick={() => onSave(false)}>Remove default user pool</NewButton>
    }
  </div>
</NewModal>

